module.exports = __webpack_public_path__ + "img/area-code.74411b33.png";